var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAction, useStorage } from "master-hook";
import { STORAGE_NAME } from "./constants";
import { STORAGE_NAME as AUTH_STORAGE_NAME } from "../use-auth/constants";
import { client } from "../services";
import { getI18nKey, isEnglish } from "../utils/common";
export var loadI18n = createAction(function (initTranslations) { return __awaiter(void 0, void 0, void 0, function () {
    var setData, i18nData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setData = useStorage(STORAGE_NAME).setData;
                if (!initTranslations) return [3 /*break*/, 1];
                setData(initTranslations);
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, client.query({
                    initTranslations: client.all,
                })];
            case 2:
                i18nData = _a.sent();
                if (i18nData && i18nData.initTranslations) {
                    setData(i18nData.initTranslations);
                }
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); });
export var t = createAction(function (inputKey, params) {
    var _a, _b;
    if (inputKey === void 0) { inputKey = ''; }
    var _c = useStorage(STORAGE_NAME), currentLang = _c.currentLang, data = _c.data, setData = _c.setData;
    if (!isEnglish(inputKey, params) &&
        !params &&
        !inputKey.includes("{") &&
        !inputKey.includes("}")) {
        return inputKey;
    }
    if (!inputKey || typeof inputKey !== 'string') {
        return '';
    }
    var key = getI18nKey(inputKey, params);
    var currentValue = (_a = data.find(function (item) { return item.lang === currentLang && item.key === key; })) === null || _a === void 0 ? void 0 : _a.translation;
    var currentValueEn = (_b = data.find(function (item) { return item.lang === 'en' && item.key === key; })) === null || _b === void 0 ? void 0 : _b.translation;
    if (!key) {
        return inputKey;
    }
    if (!data.find(function (item) { return item.key === key; })) {
        var id = Math.max.apply(Math, __spreadArray([0], data.map(function (item) { return Number(item.id) || 0; }), false)) + 1;
        var translation = inputKey
            // .replace(/[^a-zA-Z0-9{}\s.,()'"\-]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
        if (!translation) {
            return inputKey;
        }
        setData(__spreadArray(__spreadArray([], data, true), [{ id: id, key: key, translation: translation, lang: "en" }], false));
        var role = useStorage(AUTH_STORAGE_NAME).role;
        if ((role || "").toUpperCase() === "ADMIN") {
            client.mutation({
                createI18nKey: __assign(__assign({}, client.all), { __args: {
                        data: {
                            key: key,
                            originalTranslation: translation,
                            i18n: [{ translation: translation }],
                        },
                    } }),
            });
        }
    }
    if (params) {
        var replacedValue_1 = "".concat(currentValue || inputKey);
        Object.keys(params).forEach(function (k) {
            replacedValue_1 = replacedValue_1.replace("{".concat(k, "}"), String(params[k]));
        });
        return replacedValue_1;
    }
    return currentValue || currentValueEn || inputKey;
});
export var setCurrentLang = createAction(function (lang) {
    var setLang = useStorage(STORAGE_NAME).setCurrentLang;
    setLang(lang);
});
